import { apiService } from "@/services/apiService";
import { endpoints } from "@/config/endpoints";
import { pickBy } from "lodash";
import { EXPORT_FILE_EXTENSION } from "@/enums/file-type";

export default {
  getStats({
    dates,
    gmbAddressIds,
    cities,
    groups,
    comment,
    is_accurate,
    only_updated,
    only_created
  }) {
    const params = pickBy({
      date_from: dates[0],
      date_to: dates[1],
      gmb_address_ids: gmbAddressIds.join(","),
      cities: cities.join(","),
      groups: groups.join(","),
      is_accurate,
      only_updated,
      only_created
    });

    if (comment !== null) {
      params.comment = comment ? "true" : "false";
    }

    return apiService.get(endpoints.reviewsStats, {
      params
    });
  },

  getStatsTable({
    firstPeriod,
    secondPeriod,
    gmbAddressIds,
    cities,
    groups,
    page,
    perPage,
    sortBy,
    downloadFileExtension = null,
    comment,
    is_accurate,
    reviewAction,
    query
  }) {
    const params = pickBy({
      first_date_from: firstPeriod[0],
      first_date_to: firstPeriod[1],
      second_date_from: secondPeriod[0],
      second_date_to: secondPeriod[1],
      gmb_address_ids: gmbAddressIds.join(","),
      cities: cities.join(","),
      groups: groups.join(","),
      page: page,
      page_size: perPage,
      sort_by: sortBy,
      file_type: downloadFileExtension,
      is_accurate,
      review_action: reviewAction,
      q: query
    });

    if (comment !== null) {
      params.comment = comment ? "true" : "false";
    }

    return apiService.get(endpoints.reviewsStatsTable, {
      params,
      ...(downloadFileExtension == EXPORT_FILE_EXTENSION.XLSX && {
        responseType: "blob"
      })
    });
  }
};
